import React from 'react';
import { ButtonSmallTable } from '../../../global/Styles/buttons';

const formatValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value, null, 2);
  }
  return String(value);
};

const DetalleTakeoff = (props) => {
  const { detail, loading, isOpen } = props.data;
  const { handleClose } = props.actions;

  if (!isOpen) {
    return null;
  }

  const payload = detail?.data ?? detail;
  const isObject = payload && typeof payload === 'object' && !Array.isArray(payload);
  const entries = isObject ? Object.entries(payload) : [];
  const hasEntries = entries.length > 0;
  const fallbackText = !hasEntries && payload ? formatValue(payload) : '';

  return (
    <div className="min-w-screen animated fadeIn faster outline-none focus:outline-none fixed inset-0 left-0 top-0 z-50 flex h-screen items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat p-4">
      <div className="fixed inset-0 z-0 bg-black opacity-50"></div>
      <div className="relative mx-auto my-auto w-full max-w-4xl rounded-xl bg-white shadow-lg max-h-[90vh] flex flex-col">
        <div className="p-6 flex flex-col flex-grow overflow-hidden">
          <div className="mb-4 flex items-center justify-between gap-4 shrink-0">
            <h2 className="text-xl font-bold">Detalle takeoff</h2>
            <button
              onClick={handleClose}
              className="text-2xl font-bold text-gray-500 hover:text-gray-700">
              x
            </button>
          </div>

          {loading && <div className="py-6 text-center text-sm text-gray-500">Cargando...</div>}

          {!loading && !payload && (
            <div className="py-6 text-center text-sm text-gray-500">Sin detalle.</div>
          )}

          {!loading && payload && (
            <div className="flex-grow overflow-auto rounded border border-gray-200">
              {hasEntries ? (
                <table className="w-full table-auto text-sm">
                  <tbody>
                    {entries.map(([key, value]) => (
                      <tr
                        key={key}
                        className="odd:bg-white even:bg-gray-50">
                        <td className="w-1/3 px-3 py-2 text-xs font-semibold uppercase text-gray-600">{key}</td>
                        <td className="px-3 py-2 text-xs text-gray-700 whitespace-pre-wrap">{formatValue(value)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <pre className="p-3 text-xs text-gray-700 whitespace-pre-wrap">{fallbackText}</pre>
              )}
            </div>
          )}

          <div className="mt-4 flex justify-end shrink-0">
            <ButtonSmallTable
              onClick={handleClose}
              className="mb-0">
              Cerrar
            </ButtonSmallTable>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetalleTakeoff;
